import { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import videojs from 'video.js';

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import BookmarkRemoveIcon from '@mui/icons-material/BookmarkRemove';

import {
  deleteNote,
  editNote,
  getNotes
} from 'store/lesson-actions';

import classes from './Note.module.css';

const Note = props => {
  const myPlayer = videojs('lessonCourse');
  const dispatch = useDispatch();
  const [noteText, setNoteTex] = useState(props.noteData.entrada);

  const handleChangeNote = event => {
    setNoteTex(event.target.value);
  };

  const changeSecond = () => {
    myPlayer.currentTime(props.noteData.time);
  };

  const deleteNoteHandler = () => {
    (async () => {
      const deleteNoteData = await deleteNote(
        props.noteData.idEntradaApunte
      );
      if (deleteNoteData) {
        dispatch(getNotes(props.idLesson, props.academyName));
      }
    })();
  };

  const saveNoteHandler = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      (async () => {
        await editNote(props.noteData.idEntradaApunte, noteText);
      })();
    }
  };

  return (
    <aside className={classes.noteContainer}>
      <Button onClick={changeSecond} className={classes.noteBtn}>
        <PlayCircleOutlineIcon /> {props.noteData.segundo}
      </Button>
      <TextField
        value={noteText}
        onChange={handleChangeNote}
        className={classes.noteInput}
        variant="standard"
        InputProps={{
          disableUnderline: true
        }}
        multiline
        onKeyPress={saveNoteHandler}
      />
      <Button
        onClick={deleteNoteHandler}
        className={classes.noteBtn}
      >
        <BookmarkRemoveIcon />
      </Button>
    </aside>
  );
};

Note.propTypes = {
  // eslint-disable-next-line react/require-default-props
  noteData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  academyName: PropTypes.string
};

export default Note;
